import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'

import App from '@/App.vue'
import '@/plugins/fontawesome'
import '@/plugins/globals'
import '@/plugins/highcharts'
import '@/plugins/videojs'
import '@/plugins/void'
import '@/plugins/vue'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import store from '@/store'
import '@fontsource/inter' // Defaults to weight 400
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './styles/user-platform-shell.scss'
import './styles/user-platform-profile-overrides.scss'
import './styles/platform-search-overrides.scss'
import './styles/vue-dashboard-breadcrumb-overrides.scss'
import 'reflect-metadata'
import './workers/checkLoginWorker.worker.ts'

Vue.use(VueObserveVisibility)
if (window.unifiedConfig) {
  window.unifiedConfig = {
    // Temp fix until we find a better setup for micro-frontend envs
    ...window.unifiedConfig,
    orderPerformanceApi: window.unifiedConfig?.platformApiHost + '/order_performance',
    orderPerformanceApiPort: 443,
    orderPerformanceApiProtocol: 'https',
    pmnHost: window.unifiedConfig?.platformApiHost + '/pmn',
    pmnPort: 443,
    pmnProtocol: 'https',
    platformDashboardsHost: window.unifiedConfig?.platformApiHost + '/platform_dashboards',
    platformDashboardsPort: 443,
    platformDashboardsProtocol: 'https',
  }
}
const originalReplaceState = window.history.replaceState

window.history.replaceState = function (...args) {
  const newUrl = args[2]
  // Update Pendo whenever replaceState is called
  if (window.pendo && window.pendo.location && newUrl) {
    const currentPendoUrl = new URL(window.pendo.location.getHref())
    const currentBrowserUrl = new URL(window.location.origin + newUrl)
    const tab = currentPendoUrl.searchParams.get('tab')

    // If pendoUrl has tab mean user run filter in AttributionTab
    if (tab !== null) {
      currentBrowserUrl.searchParams.set('tab', tab)
    }
    window.pendo.location.setUrl(currentBrowserUrl.toString())
  }
  return originalReplaceState.apply(this, args)
}
export default function (props = {}, elementID = 'app') {
  new Vue({
    errorCaptured: Vue.config.errorHandler,
    render: (h) => h(App, { props }),
    router,
    store,
    vuetify,
  }).$mount(`#${elementID}`)
}
